import React, { useEffect, useState } from "react";
import { Col, Menu, Tooltip } from "antd";
import GoBack from "../../../../common/GoBack";
import { useLocation } from "react-router-dom";

import {
  RowDiv,
  SecStartedContent,
  Stickydiv,
  StyledSpan,
} from "../../../../../styleComponents";
import BorderDiv from "../../../../common/BorderDiv";
// import { Helmet } from "react-helmet";
import MainHeader from "../../../../common/MainHeader";
import { UAcontent } from "./content";
import LayoutPage from "../LayoutPage";
import { useNavigate } from "react-router-dom";
import { Waypoint } from "react-waypoint";

function Usinganydone({ handleWaypointEnter, handleWaypointLeave }) {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tabsValue = searchParams.get("tabid");
  const [active, setActive] = useState(tabsValue);

  const handleClick = (e) => {
    setActive(e.key);
  };
  const [content, setContent] = useState();
  useEffect(() => {
    setActive(tabsValue);
    setContent(UAcontent.content[tabsValue]);
  }, [tabsValue]);

  return (
    <div>
      <MainHeader heading={UAcontent.title} content="" />

      <Waypoint onEnter={handleWaypointEnter} onLeave={handleWaypointLeave} />

      <SecStartedContent>
        <RowDiv>
          <Col
            xs={{ span: 24 }}
            md={{ span: 5 }}
            lg={{ span: 4 }}
            className="first-column"
          >
            <Stickydiv height="19rem">
              <GoBack title="Getting Started" path="getting-started" />
              <BorderDiv mb={1} mt={1} />
              <div className="started-items">
                <Menu
                  onClick={handleClick}
                  selectedKeys={active}
                  mode="vertical"
                  className="side-menu"
                >
                  {UAcontent.content.map((items, index) => (
                    <Menu.Item
                      key={items.id}
                      onClick={() => {
                        navigate(
                          `/getting-started/using-anydone?tabid=${items.id}`
                        );
                      }}
                    >
                      {items.title}
                    </Menu.Item>
                  ))}
                </Menu>
              </div>
            </Stickydiv>
          </Col>
          {active && <LayoutPage content={content} />}
        </RowDiv>
      </SecStartedContent>
    </div>
  );
}

export default Usinganydone;
